import { Box, Heading, Text, Link } from "@chakra-ui/react";
import { Link as RouterLink } from "react-router-dom";

export default function NotFound() {
  return <Box as="main" maxW="700px" mx="auto" p="8">
    <Heading as="h1" size="lg" mb="4">페이지를 찾을 수 없습니다</Heading>
    <Text mb="4">주소가 변경되었거나 존재하지 않는 페이지입니다.</Text>
    <Link as={RouterLink} to="/" color="blue.600">홈으로 돌아가기</Link>
    <Text mt="4"><Link as={RouterLink} to="/guide" color="blue.600">이용 가이드</Link></Text>
  </Box>;
}
